import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Studio } from './components/studio'
import { Productions } from './components/productions'
import { ContactUs } from './components/contactus'
import { Footer } from './components/footer'
import SmoothScroll from 'smooth-scroll'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 84,
})

const App = () => {
  return (
    <div>
      <Navigation />
      <Header />
      <div className="gradient">
        <Studio />
        <Productions />
      </div>
      <ContactUs />
      <Footer />
    </div>
  )
}

export default App
